import { useMutation, useQueryClient } from '@tanstack/react-query'
import type { ChatSummary } from '@/features/chats/types/chat'
import { apiClient } from '@/shared/api/client'
import { workspaceChatQueryKeys } from '../queries/chats-query'

interface DeleteWorkspaceChatVariables {
  workspaceId: string
  chatId: string
}

export function useDeleteWorkspaceChatMutation() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['workspace-chat', 'delete'],
    mutationFn: ({ workspaceId, chatId }: DeleteWorkspaceChatVariables): Promise<void> =>
      apiClient.chats.deleteWorkspaceChat(workspaceId, chatId),
    onSuccess: (_, variables) => {
      queryClient.setQueryData<Array<ChatSummary>>(
        workspaceChatQueryKeys.list(variables.workspaceId),
        (current) =>
          current?.filter((chat) => chat.id !== variables.chatId) ?? [],
      )

      queryClient.removeQueries({
        queryKey: workspaceChatQueryKeys.messages(variables.workspaceId, variables.chatId),
      })
    },
  })
}
